import {Model} from '@/models/Model'
import {Order} from '@/models/Order'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import {Route} from '@/models/Route'
import {ShipStop} from '@/models/ShipStop'
import {Timeline} from '@/models/Timeline'
import {Truck} from '@/models/Truck'
import Helper from '../services/Helper.js'


export const ShippingConst = Object.freeze({
    STATUS_DRAFT: 1,
    STATUS_SUBMITTED_PENDING_CONFIRM: 2,
    STATUS_SUBMITTED_PENDING_APPROVE: 3,
    STATUS_APPROVED_PENDING_SYNC: 5,

    STATUS_SYNCED_PENDING_ACTIVE: 6,
    STATUS_DO_CONFIRMED_WAIT_STOCK: 7,

    STATUS_ISSUED_WAIT_LOAD: 8,
    STATUS_ON_DELIVERY: 9,
    STATUS_RETURN: 11,
    STATUS_OVERDUE: 12,

    STATUS_REJECT: 99,


    map(status: number): string {
        switch (status) {
            case ShippingConst.STATUS_DRAFT:
                return 'ดราฟ'
            case ShippingConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'รอยืนยัน'
            case ShippingConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'รออนุมัติ'
            case ShippingConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case ShippingConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รออนุมัติ'
            case ShippingConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'อนุมัติ'
            case ShippingConst.STATUS_ISSUED_WAIT_LOAD:
                return 'รอขนขึ้นรถ'
            case ShippingConst.STATUS_ON_DELIVERY:
                return 'กำลังขนส่ง'
            case ShippingConst.STATUS_RETURN:
                return 'เสร็จ'
            case ShippingConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    mapShort(status: number): string {
        switch (status) {
            case ShippingConst.STATUS_DRAFT:
                return 'ดราฟ'
            case ShippingConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'รอยืนยัน'
            case ShippingConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'รออนุมัติ'
            case ShippingConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case ShippingConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รออนุมัติ'
            case ShippingConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'อนุมัติ'
            case ShippingConst.STATUS_ISSUED_WAIT_LOAD:
                return 'รอขน'
            case ShippingConst.STATUS_ON_DELIVERY:
                return 'ส่ง'
            case ShippingConst.STATUS_RETURN:
                return 'เสร็จ'
            case ShippingConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    color(status: number|string): string {
        switch (parseInt(`${status}`)) {
            case ShippingConst.STATUS_DRAFT:
                return 'grey lighten-1'
            case ShippingConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'red'
            case ShippingConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'grey lighten-1'
            case ShippingConst.STATUS_APPROVED_PENDING_SYNC:
                return 'grey lighten-1'
            case ShippingConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'amber'
            case ShippingConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'lime'
            // return 'amber'
            case ShippingConst.STATUS_ISSUED_WAIT_LOAD:
                return 'lime'
            case ShippingConst.STATUS_ON_DELIVERY:
                return 'light-green'
            case ShippingConst.STATUS_RETURN:
                return 'blue-grey'
            case ShippingConst.STATUS_REJECT:
                return 'red'

        }
        // debugger
        return ''
    }

})


export class Shipping extends Model {


    declare id: number
    created_at: Date | null
    updated_at: Date | null
    code: string | null
    date_delivery: Date | null

    ship_stops: ShipStop[]

    erp_do_at: Date | null
    status: number | null

    mode: string | null
    max_cbm: number | null
    total_volume_cbm: number | null
    max_weight: number | null
    total_weight_kg: number | null
    accommodation_cost: number | null
    driver_cost: number | null
    motorway_cost: number | null
    fuel_cost: number | null
    ot_cost: number | null
    truck_code: string | null

    truck: Truck | null
    route: Route | null

    timeline: Timeline[]
    orders: Order[]
    qr: string | null

    total_net: number | null

    getSkipField(): string[] {
        return ['timeline']
    }

    getResourceURL(): string {
        return Helper.setting.shipping.getResourceAPI
    }

    async SubmitDO(): Promise<Shipping> {
        // debugger
        return await this.SetStatus(ShippingConst.STATUS_SUBMITTED_PENDING_APPROVE)
    }

    async SetStatus(status: number): Promise<Shipping> {
        // debugger
        this.status = status
        return await this.save<Shipping>()
    }

}

export class DataShipping extends DataResource {

    declare data: Shipping

}


export class DataShippingsArray extends DataArray {

    declare data: Shipping[]
    filter: FilterShipping = new FilterShipping()
}


export class FilterShipping {

    status: FilterSet = new FilterSet()
}
